var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7805 20.561C6.93116 20.561 3 16.6298 3 11.7805C3 6.93116 6.93116 3 11.7805 3C15.4654 3 18.6202 5.26994 19.9227 8.4878M4.09756 15.0732H6.65854C7.66881 15.0732 8.4878 14.2542 8.4878 13.2439V10.8659C8.4878 9.85557 9.3068 9.03658 10.3171 9.03658H12.1463C13.1566 9.03658 13.9756 8.21759 13.9756 7.20732V4.09756M17.4878 15.2927V15.2267M21 15.2163C21 17.5069 17.4878 20.561 17.4878 20.561C17.4878 20.561 13.9756 17.5069 13.9756 15.2163C13.9756 13.3188 15.5481 11.7805 17.4878 11.7805C19.4275 11.7805 21 13.3188 21 15.2163Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.402a8a505fbb96a26f990a941399baf2.svg";
export { ForwardRef as ReactComponent };